// utils/displayNameHelper.js
export const getDisplayName = (name) => {
  if (!name) return "Unknown User";
  if (typeof name === 'string') return name;
  if (typeof name === 'object' && name.stringValue) return name.stringValue;
  return "Unknown User";
};

export const getUserAvatar = (user) => {
  if (!user) return `https://ui-avatars.com/api/?name=U&background=random`;
  
  const url = user.profileUrl || user.profilePic || '';
  if (url && (url.startsWith('http') || url.startsWith('/')) && !url.includes('pravatar.cc')) return url;
  
  const name = user.displayName || user.name || 'U';
  const nameString = typeof name === 'object' ? (name.stringValue || 'U') : name;
  
  return `https://ui-avatars.com/api/?name=${encodeURIComponent(nameString)}&background=random`;
};